














import { defineComponent, PropType } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";
import { FontsType, textFonts } from "../../../../../config";

export default defineComponent({
  name: "FontType",
  components: { BaseIconButton },
  props: {
    currentFont: { type: String as PropType<FontsType>, default: FontsType.INTER },
  },
  setup(props, { emit }) {
    const changeActiveFont = (textFont: FontsType) => {
      emit("changeFont", textFont);
    };
    return {
      textFonts,
      changeActiveFont,
      FontsType,
    };
  },
});
